'use strict';

(function () {
  'use strict';

  angular.module('msTracker').component('msMoodButtons', {
    bindings: {
      tracker: '<',
      readOnly: '<',
      inputValue: '<',
      outputValue: '&',
      moodButtonsLoaded: '&'
    },
    templateUrl: 'tracker/templates/mood-buttons.html',
    controller: ['$timeout', '$window', '$scope', function ($timeout, $window, $scope) {
      var vm = this;
      vm.$onInit = _init;
      vm.dirtyState = false;
      vm.possibleTrackerValues = [-1.0, -0.5, 0, 0.5, 1.0];

      function _init() {
        if (vm.inputValue || vm.inputValue === 0) {
          _setdirtyState(vm.inputValue);
        }

        // Run 'moodButtonsLoaded' callback to let parent component know that mood buttons rendered after 1500 ms;
        $timeout(function () {
          vm.moodButtonsLoaded();
        }, 1500);

        // Keydown listener for 'tab' key to put focus on selected mood button
        $window.addEventListener('keydown', _focusOnSelected);
        $scope.$on('$destroy', function () {
          return $window.removeEventListener('keydown', _focusOnSelected);
        });
      }

      vm.clickTrackerButton = function (value) {
        _setdirtyState(value);
        vm.outputValue({
          value: value
        });
      };

      function _setdirtyState(value) {
        vm.selectedValue = value;
        vm.dirtyState = true;
      }

      function _focusOnSelected(event) {
        // Check if pressed button is 'tab' (keyCode for 'tab' = 9)
        if (event.keyCode !== 9) {
          return;
        }
        // Do event.preventDefault() to keep focus on selected button  
        var selectedElement = $window.document.querySelector('#selectedTracker');
        if (selectedElement) {
          event.preventDefault();
          selectedElement.focus();
          // Remove listener to clear event.preventDefault() for 'tab' key
          $window.removeEventListener('keydown', _focusOnSelected);
        }
      }
    }]

  });
})();